import React, { useState } from 'react';
import { CHAT_HEADER_TEXT, CHAT_BUTTON_TEXT } from './src-config-app-config.js';

const CAContext = React.createContext({
  chatState: {
    tenant: "vistaprint",
    locale: "en-us",
    chatWindow: "minimized",
    chatButtonText: CHAT_BUTTON_TEXT.CHATBOT,
    chatHeaderText: CHAT_HEADER_TEXT.CHATBOT,
    chatWindowHandler: () => {
    },
    chatButtonHandler: () => {
    }
  },
  setChatState: () => {
  }
});
const CAProvider = ({
  children,
  locale,
  // pageInfo,
  chatWindow,
  chatSession,
  enableChatbot,
  unreadMessages,
  scrollToBottom,
  isPrivacyPolicyAccepted,
  chatButtonText,
  chatHeaderText,
  tenant
}) => {
  const [state, setState] = useState({
    tenant,
    locale,
    chatWindow,
    chatSession,
    enableChatbot,
    unreadMessages,
    scrollToBottom,
    isPrivacyPolicyAccepted,
    chatButtonText,
    chatHeaderText,
    chatButtonHandler: () => {
    },
    chatWindowHandler: () => {
    }
  });
  return /* @__PURE__ */ React.createElement(
    CAContext.Provider,
    {
      value: {
        chatState: state,
        setChatState: setState
      }
    },
    children
  );
};

export { CAContext, CAProvider };
//# sourceMappingURL=src-contexts-CAContext.js.map
